module.exports = __webpack_public_path__ + "img/dzhc.ce885ba2.png";